export default "__VITE_ASSET__75200d31__"